import { Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../../../../../components/checkbox/Checkbox";
import CustomInput from "../../../../../../../components/customInput/CustomInput";
import CoursePick from "../../../../OdobrenjeAplikacija/PostKomentar/CoursePick";
import SelectDropdown from "../../selectDropdown/SelectDropdown";
import styles from "../EnrollmentForm.module.css";
import UserInfo from "../UserInfo";
import { attendanceMappingTT } from "../utils";
function TTForm({
  userId,
  formMethodsFive,
  handleResetForm,
  programApplicationId,
  applicationsCreated,
  evidentionUserID,
  isAccepted,
  errorFields,
  application,
  commentModal,
  fetchApplicationCallback,
}) {
  const navigate = useNavigate();
  const getCourseContext = (course) => {
    return {
      userId,
      application,
      commentModal,
      course,
      evidentionUserID,
      fetchApplicationCallback,
    };
  };
  const getBackgroundColor = (fieldName, value) => {
    return attendanceMappingTT[fieldName] >= Number(value)
      ? "#FEE8E8"
      : "#E8FEE8";
  };
  return (
    <div>
      <div className={styles.formInputsContainer}>
        {userId !== "Polaznik" && (
          <UserInfo
            evidentionUserID={
              evidentionUserID ? evidentionUserID : application?.userId
            }
            course={"TT"}
          />
        )}
        <p className={styles.formSectionText}>
          Uvjet za upis 5. g. je ostvaren status Praktičara. Za izlazak na
          obranu CS1 čime se stječe status Praktičara potrebno je imati u
          cijelosti završen program OR kao i ispod navedeni broj sati IPR-a,
          GPR-a, individualnih supervizija i suglasnost sva tri tvoja
          supervizora. U slučaju slobodnih mjesta Škola može primiti na TT i one
          edukante koji su najbliže ispunjenju uvjeta za status Praktičara.
        </p>
        <Controller
          control={formMethodsFive.control}
          name="TTEvidentionIPRHours"
          render={({ field: { value } }) => (
            <CustomInput
              value={value}
              name="TTEvidentionIPRHours"
              labelText="Broj sati IPR-a (programskih terapija, min 60 sati):"
              placeholder="Upiši"
              disabled={true}
              backgroundColor={getBackgroundColor(
                "TTEvidentionIPRHours",
                formMethodsFive.watch("TTEvidentionIPRHours")
              )}
            />
          )}
        />
        <Controller
          control={formMethodsFive.control}
          name="TTEvidentionGPRHours"
          render={({ field: { value } }) => (
            <CustomInput
              value={value}
              name="TTEvidentionGPRHours"
              labelText="Broj sati GPR-a (grupnog psihoterapijskog rada, min 90 sati):"
              placeholder="Upiši"
              disabled={true}
              backgroundColor={getBackgroundColor(
                "TTEvidentionGPRHours",
                formMethodsFive.watch("TTEvidentionGPRHours")
              )}
            />
          )}
        />
        <Controller
          control={formMethodsFive.control}
          name="TTEvidentionIndividualSupervisions"
          render={({ field: { value } }) => (
            <CustomInput
              value={value}
              name="TTEvidentionIndividualSupervisions"
              labelText="Broj sati individualnih supervizija (1na1 ili izlagač na AGS-u, min 15 sati):"
              placeholder="Upiši"
              disabled={true}
              backgroundColor={getBackgroundColor(
                "TTEvidentionIndividualSupervisions",
                formMethodsFive.watch("TTEvidentionIndividualSupervisions")
              )}
            />
          )}
        />
        <Controller
          control={formMethodsFive.control}
          name="TTEvidentionGroupSupervisions"
          render={({ field: { value } }) => (
            <CustomInput
              value={value}
              name="TTEvidentionGroupSupervisions"
              labelText="Broj sati grupne supervizije:"
              placeholder="Upiši"
              disabled={true}
            />
          )}
        />
        <Controller
          control={formMethodsFive.control}
          name="TTWorkWithClientsHours"
          render={({ field: { value } }) => (
            <CustomInput
              value={value}
              name="TTWorkWithClientsHours"
              labelText="Broj sati rada s klijentima (min 20 sati):"
              placeholder="Upiši"
              disabled={true}
              backgroundColor={getBackgroundColor(
                "TTWorkWithClientsHours",
                formMethodsFive.watch("TTWorkWithClientsHours")
              )}
            />
          )}
        />
        <div className={styles.displayRow}>
          <Controller
            control={formMethodsFive.control}
            name="TTSupervisorApproval"
            render={({ field: { value } }) => (
              <Checkbox
                value={value}
                disabled={true}
                name="TTSupervisorApproval"
                label="Potvrda o radu s klijentima"
              />
            )}
          />
          <Controller
            control={formMethodsFive.control}
            name="TTZavrsniOR"
            render={({ field: { value } }) => (
              <Checkbox
                value={value}
                disabled={true}
                name="TTZavrsniOR"
                label="Napisan Završni rad OR-a"
              />
            )}
          />
          <Controller
            control={formMethodsFive.control}
            name="TTCaseStudyOne"
            render={({ field: { value } }) => (
              <Checkbox
                value={value}
                disabled={true}
                name="TTCaseStudyOne"
                label="Obranjena Studija slučaja 1 (CS1)"
              />
            )}
          />
        </div>
        <Controller
          control={formMethodsFive.control}
          name="selectOneTT"
          render={({ field: { onChange, onBlur, value } }) => (
            <SelectDropdown
              name="selectOneTT"
              title="Ako nemaš sve ispunjene uvjete označi do kada planiraš ispuniti sve navedene uvjete i izaći na obranu CS1? (odaberu jednu od opcija)"
              onChange={
                userId !== "Referada" && !programApplicationId && onChange
              }
              error={errorFields.find((field) => field === "selectOneTT")}
              onBlur={onBlur}
              value={value}
              disabled={
                programApplicationId ||
                applicationsCreated["TT"] ||
                evidentionUserID
              }
              initialOption={!programApplicationId ? "Odaberi" : value}
              options={[
                "6. mjesec",
                "9. mjesec",
                "12. mjesec",
                "3. mjesec sljedeće godine",
              ]}
            />
          )}
        />
        <Controller
          control={formMethodsFive.control}
          name="checkOneTT"
          render={({ field: { onChange, onBlur, value } }) => (
            <Checkbox
              onBlur={onBlur}
              onChange={
                userId !== "Referada" && !programApplicationId && onChange
              }
              error={errorFields.find((field) => field === "checkOneTT")}
              value={value}
              disabled={applicationsCreated["TT"] || evidentionUserID}
              name="checkOneTT"
              label="Potvrđujem da primam na znanje da Škola ITP-a dodjeljuje diplomu prema uvjetima koje propisuju EAP i EABP te da su nosioci diplome dužni svoje zvanje i legalnost rada prilagoditi zakonima ili propisima o djelatnosti psihoterapije koji vrijede u državi u kojoj žele raditi."
            />
          )}
        />
        <Controller
          control={formMethodsFive.control}
          name="checkTwoTT"
          render={({ field: { onChange, onBlur, value } }) => (
            <Checkbox
              onBlur={onBlur}
              onChange={
                userId !== "Referada" && !programApplicationId && onChange
              }
              error={errorFields.find((field) => field === "checkTwoTT")}
              value={value}
              disabled={applicationsCreated["TT"] || evidentionUserID}
              name="checkTwoTT"
              label="Potvrđujem da sam upoznat sa Zakonom o djelatnosti psihoterapije u Hrvatskoj koji kaže: Djelatnost psihoterapije obavlja ovlašteni psihoterapeut ili ovlašteni savjetodavni terapeut. Za status savjetodavnog terapeuta potrebno je imati minimalno status Sveučilišnog prvostupnika (Baccalaureus) stručnog prvostupnik ili VŠS (prije Bologne) i uz to imati završenu Propedeutiku psihoterapije. Za status psihoterapeuta neki od navedenih fakulteta (medicinske znanosti, kliničke medicinske znanosti, javnog zdravstva i zdravstvene zaštite, psihologije, socijalne djelatnosti, edukacijsko-rehabilitacijske znanosti, pedagogije i logopedije)"
            />
          )}
        />
        <Controller
          control={formMethodsFive.control}
          name="checkThreeTT"
          render={({ field: { onChange, onBlur, value } }) => (
            <Checkbox
              onBlur={onBlur}
              onChange={
                userId !== "Referada" && !programApplicationId && onChange
              }
              error={errorFields.find((field) => field === "checkThreeTT")}
              value={value}
              disabled={applicationsCreated["TT"] || evidentionUserID}
              name="checkThreeTT"
              label="U većini zemalja (Srbija, Slovenija, BiH, S. Makedonija, Crna Gora i mnoge druge zemlje, djelatnost psihoterapije još nije regulirana zakonski, ali primam na znanje da sam obavezan/na svoj terapeutski rad i svoje predstavljanje prilagoditi postojećim propisima u zemlji u kojoj namjeravam raditi."
            />
          )}
        />
      </div>
      {userId !== "Referada" && !programApplicationId && !evidentionUserID && (
        <div className={styles.formButtonsContainer}>
          {!applicationsCreated["TT"] && (
            <div
              className={
                userId === "Referada"
                  ? `${styles.disabled} ${styles.cancelButton}`
                  : styles.cancelButton
              }
              onClick={() => {
                if (userId !== "Referada") {
                  formMethodsFive.reset();
                  navigate(-1);
                }
              }}
              disabled={true}
            >
              odustani
            </div>
          )}
          <div
            className={
              userId === "Referada" || applicationsCreated["TT"]
                ? `${styles.disabled} ${styles.sendButton}`
                : styles.sendButton
            }
            onClick={() => {
              if (userId !== "Referada") handleResetForm(formMethodsFive);
            }}
            disabled={applicationsCreated["TT"]}
          >
            {applicationsCreated["TT"] ? "Poslano" : "Pošalji prijavu"}
          </div>
        </div>
      )}
      <CoursePick context={getCourseContext("TT")} />
      {userId === "Polaznik" &&
        !evidentionUserID &&
        !programApplicationId &&
        applicationsCreated["TT"] && (
          <>
            {isAccepted["TT"] !== false && (
              <div
                className={styles.acceptanceContainer}
                style={{
                  backgroundColor:
                    isAccepted["TT"] === true &&
                    commentModal["TT"]?.isReferadaAccepted === true
                      ? "#e8fee8"
                      : "#F8F9FB",
                }}
              >
                {isAccepted["TT"] === true &&
                commentModal["TT"]?.isReferadaAccepted === true
                  ? "Primljeni ste"
                  : "Vaša aplikacija je zaprimljena"}
              </div>
            )}
          </>
        )}
    </div>
  );
}

export default TTForm;
